import { FaCaretDown } from "react-icons/fa6";

import { cn } from "@/lib/utils/cn";
import { MenuSectionProps } from "@/lib/types/nav";
import MenuSectionLink from "./MenuSectionLink";

export default function MenuSection({
  section,
  handleClose,
  accentColor,
  textColor,
  linkClassName,
}: MenuSectionProps) {
  const Icon = section.icon;
  const openAccentClass = accentColor;
  const openTextClass = textColor;

  return (
    <details name="mobile-menu-sections" className="group w-full">
      <summary
        className={cn(
          "flex min-w-full cursor-pointer list-none items-center justify-between border-b px-2 py-6 text-left font-semibold uppercase [&::-webkit-details-marker]:hidden [&::marker]:hidden",
          openAccentClass,
        )}
      >
        <span className="flex items-center gap-3">
          <Icon
            size={section.iconSize ?? 25}
            className={cn(openTextClass)}
          />
          <span className={cn("font-semibold", openTextClass)}>
            {section.label}
          </span>
        </span>
        <FaCaretDown
          size={20}
          className={cn(
            "rotate-90 group-open:rotate-0",
            openTextClass,
          )}
        />
      </summary>
        <ul
          className="ml-1 mt-3 flex flex-col gap-3 pl-4 text-base font-medium"
        >
          {section.items.map((item, index) => (
            <MenuSectionLink
              key={item.href}
              item={item}
              handleClose={handleClose}
              index={index}
              lastIndex={section.items.length - 1}
              className={linkClassName}
            />
          ))}
        </ul>
    </details>
  );
}
